import React from "react";
import "./Hosting.css";
import { Helmet } from "react-helmet";

export default function Hosting() {
  return (
    <div className="hosting-page">

      {/* SEO + GEO */}
      <Helmet>
        <title>Best Web Hosting & Domain in Pakistan 2026 | SamSoftix Deals</title>

        <meta
          name="description"
          content="Buy cheap web hosting and domain in Pakistan with exclusive Hostinger discount code. Fast SSD hosting, free SSL, free domain. Limited-time deal by SamSoftix."
        />

        <meta
          name="keywords"
          content="web hosting Pakistan, buy domain Pakistan, cheap hosting Pakistan, Hostinger Pakistan, domain registration Pakistan, best hosting 2026, global hosting deals"
        />

        {/* GEO */}
        <meta name="geo.region" content="PK" />
        <meta name="geo.placename" content="Pakistan" />
        <meta name="geo.position" content="33.6844;73.0479" />
        <meta name="ICBM" content="33.6844, 73.0479" />

        {/* Open Graph */}
        <meta property="og:title" content="Best Hosting Deals in Pakistan - SamSoftix" />
        <meta property="og:description" content="Get hosting + domain with discount. Limited-time offer." />
        <meta property="og:type" content="website" />

        {/* Schema */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "Web Hosting Pakistan",
            "brand": {
              "@type": "Brand",
              "name": "Hostinger"
            },
            "description": "Affordable hosting and domain services in Pakistan with discount.",
            "offers": {
              "@type": "Offer",
              "priceCurrency": "USD",
              "price": "2.99",
              "availability": "https://schema.org/InStock"
            }
          }
          `}
        </script>
      </Helmet>

      {/* HERO */}
      <section className="hosting-hero">
        <h1>🚀 Best Web Hosting in Pakistan (Save 20%)</h1>

        <p>
          Looking for reliable hosting in Pakistan? Get fast, secure, and affordable
          hosting trusted by users in <strong>Islamabad, Lahore, Karachi</strong> and worldwide.
        </p>

        <p>
          💰 Buy through our link & get <strong>extra development discounts from SamSoftix</strong>
        </p>

        <a
          className="cta-btn big"
          href="https://hostinger.com?REFERRALCODE=E2CQASIMC7DN"
          target="_blank"
          rel="noopener noreferrer"
        >
          👉 Get Hosting Now
        </a>
      </section>

      {/* TRUST */}
      <p className="trust-text">
        ⭐ Trusted globally | 🌍 Used in 150+ countries | ⏳ Limited-Time Offer
      </p>

      {/* MAIN OFFER */}
      <div className="offer-box highlight-offer">
        <h2>🌐 20% OFF Hosting + Free Domain</h2>

        <p>
          High-speed SSD hosting, free SSL, and global servers for maximum performance.
        </p>

        <p>
          🎁 Promo Code: <strong>E2CQASIMC7DN</strong>
        </p>

        <a
          className="cta-btn"
          href="https://hostinger.com?REFERRALCODE=E2CQASIMC7DN"
          target="_blank"
          rel="noopener noreferrer"
        >
          🔥 Claim Discount Now
        </a>

        <p className="mini-note">
          ⚡ Only available via SamSoftix referral
        </p>
      </div>

      {/* BONUS */}
      <div className="offer-box bonus-offer">
        <h2>🎁 Extra Bonus for You</h2>

        <p>
          Get <strong>hosting discount + additional discount on website development</strong>
          services from SamSoftix.
        </p>

        <ul className="bonus-list">
          <li>✔ Website Development</li>
          <li>✔ E-commerce Stores</li>
          <li>✔ Custom Software</li>
        </ul>

        <p className="mini-note">
          📩 Contact us after purchase with proof to claim your bonus
        </p>
      </div>

      {/* KEYWORDS SECTION */}
      <section className="features">
        <h2>Best Hosting Features</h2>
        <ul>
          <li>✔ Fast SSD Hosting</li>
          <li>✔ Free Domain Registration</li>
          <li>✔ Free SSL Certificate</li>
          <li>✔ 99.9% Uptime</li>
          <li>✔ Beginner Friendly</li>
        </ul>
      </section>

      {/* GEO CONTENT */}
      <section className="domain-section">
        <h2>Cheap Domain & Hosting in Pakistan</h2>
        <p>
          Easily buy domain and hosting in Pakistan with lowest prices.
          Perfect for bloggers, freelancers, and businesses across Pakistan and globally.
        </p>
      </section>

      {/* FAQ (VERY IMPORTANT) */}
      <section className="faq">
        <h2>Frequently Asked Questions</h2>

        <h3>Which is the best hosting in Pakistan?</h3>
        <p>
          Hostinger is one of the best hosting providers due to its affordability,
          speed, and reliability.
        </p>

        <h3>Can I buy domain and hosting together?</h3>
        <p>
          Yes, you can get a free domain with hosting plans using our referral link.
        </p>

        <h3>Is this hosting good for beginners?</h3>
        <p>
          Yes, it includes an easy control panel and one-click WordPress setup.
        </p>
      </section>

      {/* FINAL CTA */}
      <section className="cta-section">
        <h2>⏳ Limited Time Deal</h2>

        <p>
          Prices may increase soon. Secure your hosting today and start your website instantly.
        </p>

        <a
          className="cta-btn big"
          href="https://hostinger.com?REFERRALCODE=E2CQASIMC7DN"
          target="_blank"
          rel="noopener noreferrer"
        >
          🚀 Start Now & Save 20%
        </a>

        <p className="trust-text">
          🔒 Secure • Fast • Trusted Worldwide
        </p>
      </section>

    </div>
  );
}